import styled from "@emotion/styled";
import { Button } from "react-aria-components";
import { Theme } from "@emotion/react";

// Shared base styles
const sharedSectionStyles = ({ theme }: { theme: Theme }) => `
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${theme.spacing["0.5"]};

  width: 100%;
  padding: ${theme.spacing["2"]};
  background-color: ${theme.colors.background.button.onChrome.default};
  border-radius: ${theme.borderRadius.xlarge};
  border: none;
  cursor: pointer;
  font-family: inherit;

  &:hover:not(:disabled) {
    background-color: ${theme.colors.background.button.onChrome.hover};
    transition: 0.2s all;
  }

  &:hover:not(:disabled) [data-right-buttons] {
    opacity: 1;
    width: auto;
  }

  &:disabled {  
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const StyledSectionItemContainer = styled.div<{ $indent?: boolean }>`
  ${sharedSectionStyles}
  margin-left: ${({ $indent, theme }) => ($indent ? theme.spacing["2"] : 0)};
  width: ${({ $indent, theme }) => ($indent ? `calc(100% - ${theme.spacing["2"]})` : "100%")};
`;

export const StyledSectionHeaderContainer = styled(Button)`
  ${sharedSectionStyles}

  // Always show the right buttons on mobile
  @media (${({ theme }) => theme.breakpoints.phone}) {
    [data-right-buttons] {
      opacity: 1;
      width: auto;
    }
  }
`;

export const StyledSectionItemContainerLeft = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
`;

export const StyledSectionItemContainerRight = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  flex-shrink: 0;
  opacity: 0;
  width: 0;
  overflow: hidden;
  transition:
    opacity 0.2s ease,
    width 0.2s ease;
`;
